export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./cashback.vue?vue&type=template&id=0ab3ae51&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/bonuses/cashback.vue?vue&type=template&id=0ab3ae51&scoped=true
// module id = FdBs
// module chunks = 0